import { createComponent } from '../core/create-component.js';
const IconTileDescription = createComponent({
  displayName: 'IconTileDescription',
  root: 'div',
  propConfig: {
    classNames: ['swan-icon-tile-description']
  }
});
export { IconTileDescription };